/// <amd-module name="Feed/Admin/NormalizedGlobalPermission" />
import { IdentityDescriptor } from "VSS/Platform/Contracts/Identities";

import { GlobalPermission, GlobalRole } from "Feed/Common/Contracts/Feed";
import { INormalizedGlobalPermission } from "Types";

export class NormalizedGlobalPermission implements INormalizedGlobalPermission {
    /**
     * @param identityDescriptor IdentityDescriptor is typed as an object, but it actually gets
     *      transmitted both directions as a string, so that's awkward
     * @see {@link GlobalPermission} except with the type of identity descriptor normalized to a string
     */
    constructor(public identityDescriptor: string, public role: GlobalRole, public identityId: string) {
        if (typeof identityDescriptor !== "string" || typeof role !== "number") {
            throw new Error();
        }
    }

    public static fromGlobalPermission(original: GlobalPermission): NormalizedGlobalPermission {
        return new NormalizedGlobalPermission(
            NormalizedGlobalPermission.normalizeIdentityDescriptorToString(original.identityDescriptor),
            original.role,
            original.identityId
        );
    }

    public toGlobalPermission() {
        return <GlobalPermission>{
            identityDescriptor: <any>this.identityDescriptor,
            role: this.role,
            identityId: this.identityId
        };
    }

    /** Normalize an identity descriptor (which may actually be a string or an object) to a string */
    public static normalizeIdentityDescriptorToString(identityDescriptor: IdentityDescriptor | string): string {
        if (typeof identityDescriptor === "string") {
            return identityDescriptor;
        }

        return `${identityDescriptor.identityType};${identityDescriptor.identifier}`;
    }
}
